import { TextField, TextFieldProps } from '@mui/material';
import {
  DateOrTimeView,
  DateTimePicker,
  DateTimePickerProps,
} from '@mui/x-date-pickers';
import { formatISO, parseISO } from 'date-fns';
import { Controller, useFormContext } from 'react-hook-form';

type IProps = Omit<DateTimePickerProps<Date>, 'renderInput'> & {
  name: string;
  label: string;
  textFieldProps?: TextFieldProps;
  minDateTime?: Date;
  maxDateTime?: Date;
  views?: DateOrTimeView[];
  format?: string;
};

export const DateTimePickerInput = ({
  name,
  label,
  textFieldProps,
  minDateTime,
  maxDateTime,
  views,
  format,
  ...rest
}: IProps) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => (
        <DateTimePicker
          label={label}
          value={field.value ? parseISO(field.value) : null}
          onChange={newValue => {
            const value = newValue
              ? formatISO(newValue, { representation: 'complete' })
              : '';
            field.onChange(value);
          }}
          minDateTime={minDateTime} // Block selection before this date and time
          maxDateTime={maxDateTime} // Block selection after this date and time
          ampm={false} // Ensure 24-hour format
          views={views}
          format={format}
          slots={{ textField: TextField }}
          slotProps={{
            textField: {
              error: !!fieldState.error,
              helperText: fieldState.error?.message,
              ...textFieldProps,
            },
          }}
          {...rest}
        />
      )}
    />
  );
};
